import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.12)" },
    "100%": { transform: "scale(1)" }
  },
  "@keyframes pulseRing": {
    "0%": { transform: "translate(-50%, -50%) scale(1)", opacity: 0.5 },
    "70%": { transform: "translate(-50%, -50%) scale(1.8)", opacity: 0 },
    "100%": { opacity: 0 }
  },
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    paddingTop: 2
  },
  active: {
    background: theme.palette.primary.light,
    animation: 'none',
    transformOrigin: 'center',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) scale(1)',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: `2px solid ${theme.palette.primary.main}`,
      opacity: 0.5,
      animation: '$pulseRing 1.6s ease-out infinite'
    }
  },
  completed: {
    background: theme.palette.primary.main,
  },
}));
